<template>
  <div>
    <van-sticky>
      <van-nav-bar :border="false">
        <template #title>
          <strong>{{ currentRole === 0 ? '' : '代理' }}个人中心</strong>
        </template>
      </van-nav-bar>
    </van-sticky>
    <mr-card-header :header="{ name: currentRole === 0 ? userInfo.nickname : agentInfo.username, avatar: userInfo.domain + userInfo.avatar, words, toLink, count: currentRole === 0 ? musicCount : agentCount }" to="/me/update-info"></mr-card-header>
    <div class="list mt-15">
      <van-cell v-for="item in list" :key="item.title" :border="item.border" :value="item.value" :title="item.title" :to="item.to" is-link></van-cell>
      <van-cell v-if="userInfo.is_agent === 1" title="切换身份" :value="currentRoleText" @click.native="toggleBody" is-link></van-cell>
      <van-cell v-if="agentInfo.type === '公司业务员' && currentRole === 1" title="创建代理" to="/agent/generate-agent" is-link></van-cell>
      <van-cell v-if="agentInfo.type === '公司业务员' && currentRole === 1" title="代理链接" to="/agent/generate-list" is-link></van-cell>
    </div>
    <div class="pl-15 pr-15 pb-50">
      <van-button type="default" block @click="logout">退出登陆</van-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import MrCardHeader from '@/components/card-header'
import { getMusicCount } from '@/api/common.js'
import { getAgentDownNumber, getAgentSign, getAgentIdentity } from '@/api/agent.js'
export default {
  name: 'Me',
  components: { MrCardHeader },
  data() {
    return {
      music: {},
      agentCountInfo: {} // 代理统计信息
    }
  },
  computed: {
    musicCount() {
      const { issue_music_cnt, issue_album_cnt, music_cnt, album_cnt } = this.music
      const issueCnt = issue_music_cnt + issue_album_cnt
      const cnt = music_cnt + album_cnt - issueCnt
      return [issueCnt, cnt]
    },
    agentCount() {
      const { my_music, 直属代理实名代理, 直属代理未实名代理 } = this.agentCountInfo
      const musicer = my_music
      const agenter = (直属代理实名代理 || 0) + (直属代理未实名代理 || 0)
      return [musicer, agenter]
    },
    list() {
      return [
        { title: '账单核对', border: false, to: this.currentRole === 0 ? '/bill' : '/agent/bill' },
        { title: '提现功能', border: false, to: this.currentRole === 0 ? '/withdraw' : '/agent/withdraw' },
        { title: '修改信息', border: false, to: '/me/update-info' },
        { title: '修改密码', border: true, to: '/me/reset-pwd' },
        { title: '关于三咖', border: false, to: '/about' }
      ]
    },
    toLink() {
      return this.currentRole === 0 ? ['/music/list?type=6,7', '/music/list?type=1,2,3'] : ['/agent/downline', '/agent/downline?type=1']
    },
    words() {
      return this.currentRole === 0 ? ['已发行作品', '未上线作品'] : ['我的音乐人', '我的代理']
    },
    currentRoleText() {
      let txt = '当前身份：'
      if (this.currentRole === 0){
        txt += '音乐人'
      } else if (this.currentRole === 1 && this.agentInfo.type === '公司业务员') {
        txt += '业务员'
      } else {
        txt += '代理商'
      }
      return txt
    },
    ...mapState(['userInfo', 'currentRole', 'agentInfo', 'isPlus'])
  },
  async created() {
    try {
      this.$store.commit('TOGGLE_LOADING', true)
      await this.getMusicCount()
      // 只有是代理身份的时候才会请求代理的下载数量
      this.userInfo.is_agent === 1 && await this.getAgentDownNumber()
    } finally {
      this.$store.commit('TOGGLE_LOADING', false)
    }
    // 当前为代理身份时，需要判断当前身份是否验证了，没有验证则切换为音乐人身份
    if (this.currentRole === 1 && (this.agentInfo.is_verify === 0 || this.agentInfo.is_sign === 0)) {
      this.TOGGLE_ROLE()
    }
  },
  methods: {
    async getMusicCount() {
      const res = await getMusicCount({})
      this.music = res.data
    },
    async getAgentDownNumber() {
      const res = await getAgentDownNumber({})
      this.agentCountInfo = res.data
    },
    async logout() {
      await this.$store.dispatch('logout')
      this.$router.push('/login')
    },
    async toggleBody() {
      this.TOGGLE_ROLE()
      this.$store.commit('TOGGLE_LOADING', true)
      try {
        await this.$store.dispatch('getAgentInfo')
        if (this.currentRole === 1 && this.agentInfo.is_verify === 0) {
          // 代理实名
       /*    0=不跳
          1=H5首页
          2=CP下载页
          3=代理下载页 */
          const res = await getAgentIdentity({ jump: this.isPlus ? 1 : 3 })
          res.data && (location.href = res.data.url)
          return
        }
        if (this.currentRole === 1 && this.agentInfo.is_sign === 0) {
          // 代理签约
          const res = await getAgentSign({ jump: this.isPlus ? 1 : 3 })
          location.href = res.data.url
          return
        }
        this.$toast(`您当前的身份为${this.currentRole === 0 ? '音乐人' : '代理商'}`)
      } catch {
        this.TOGGLE_ROLE()
      } finally {
        this.$store.commit('TOGGLE_LOADING', false)
      }
    },
    ...mapMutations(['TOGGLE_ROLE'])
  }
}
</script>

<style lang="scss" scoped>
.list{
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  overflow: hidden;
  box-shadow:  0 -1px 2px 0#eff1f2;
}
.agent{
  position: fixed;
  top: 170px;
  right: 30px;
  width: 55px;
  color: #fff;
  border-radius: 50%;
  padding: 10px;
  text-align: center;
  box-sizing: border-box;
  font-size: 12px;
  background-image: linear-gradient(150deg,#755bea,#ff72c0);
  user-select: none;
  &:active{
  background-image: linear-gradient(-150deg,#755bea,#ff72c0);
  }
}
</style>
